<template>
<!-- <div class="input-group" >-->
      <input type="text" class="form-control text-center" :maxlength="maxLength" :value="inimsg" ref="input" @blur="Blur" @focus="Focus" /> 
<!--</div>	-->	
</template>

<script>
export default{
	name: 'UserCheckInput',
	data() {
			return {	
				userId:'',
				userName:''

				
			}
	},
	props: {	
			url:{
				default:'/system/users/username?UserName='
			},
			nofoundmsg:{
				default:'不存在该用户'
			},
			inimsg:{
				default:'输入用户名查询'
			},
			maxLength:{
				default:20
			}
	},
	methods :{
		beforeMount() {
			//this.$refs.input.value = this.userInputSetting.inimsg==undefined?this.defaultSetting.inimsg:this.userInputSetting.inimsg;
		},
		
		Blur(){
			if(this.$refs.input.value ==''){
				this.userId = '';	
				this.setUserId();	
				this.$refs.input.value = this.inimsg;
				return;
			}	
			this.$http.get(process.env.API_ROOT + this.url+this.$refs.input.value)
				.then( res => {
					if(res.body.success){
						//未查到
						if(res.data.data ==null){
							this.$refs.input.value =this.nofoundmsg
							this.userId='';
							this.setUserId(); 
						}else{
							this.userId = res.data.data;
							this.setUserId();
						}
						return;
					}
					this.setUserId();
				})
		},
		Focus(){
			this.$refs.input.value = '';
			this.userId = '';	
		},
		setUserId:function(){
			this.$emit('setUserId',this.userId)
		}
		
			
	}
			
}
	
	
</script>

<style>
	
	
</style>


// WEBPACK FOOTER //
// UserCheckInput.vue?09d7f9d0